import { render, staticRenderFns } from "./MergeContactPhones.vue?vue&type=template&id=7089e176&scoped=true&"
import script from "./MergeContactPhones.vue?vue&type=script&lang=js&"
export * from "./MergeContactPhones.vue?vue&type=script&lang=js&"
import style0 from "./MergeContactPhones.vue?vue&type=style&index=0&id=7089e176&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7089e176",
  null
  
)

export default component.exports